import { render, staticRenderFns } from "./AIAssistantButton.vue?vue&type=template&id=46ae2d5e"
import script from "./AIAssistantButton.vue?vue&type=script&lang=js"
export * from "./AIAssistantButton.vue?vue&type=script&lang=js"
import style0 from "./AIAssistantButton.vue?vue&type=style&index=0&id=46ae2d5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports